<style lang="scss" src="./style.scss" scoped></style>
<script src="./script"></script>
<template>
    <breadcrumb :links="breadcrumb"></breadcrumb>
    <div class="page">
      <div class="page-header p-3">
          <h1>Ref là gì?</h1>
      </div>
      <div class="page-body p-3">
        <div>
          Khi CPD đã hết hạn bạn muốn chạy lại CPD 1 lần nữa thì lúc này COST của CPD đã có sự thay đổi. Ref được tạo như là một lần chaỵ tiếp theo của CPD đó nhưng không làm thay đổi thông tin của CPD trong quá khứ.
        </div>
        <div>
          Khi một ref mới được tạo ra, thì CPD cũ sẽ bị khóa, dữ liệu về cost sẽ không thể thay đổi, vì thế hãy xem xét trước khi tạo ref.
        </div>

        <div class="mt-3">
          Khi tạo ref sẽ lưu lại số lần chạy của CPD đó, click vào link tại cột "Lần chạy" ở danh sách CPD để xem lịch sử.
        </div>

        <doc-menu class="mt-5"></doc-menu>
      </div>
    </div>
  </template>